var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.callModalAction.apply(null, arguments)}}},[_c(_vm.type,{tag:"component",on:{"toggleModal":_vm.callModalSecondAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }